import { ReactElement } from 'react';
import { ImageGridDynamicComponent } from './ImageGrid';
import { TextX, TextY } from '~/types/style';

export const ImageGridContainer = ({
  imageGridData,
}: {
  imageGridData: Queries.ImageGridFragmentFragment;
}): ReactElement => {
  const {
    textXAlignment,
    textYAlignment,
    textXAlignmentMobile,
    textYAlignmentMobile,
    hoverEffect,
    gridBehavior,
    richImages,
    optionalImageIcon,
  } = imageGridData;

  const richImagesOrDefault = (richImages ?? []) as Queries.RichImageFragmentFragment[];
  const textY: TextY = textYAlignment ?? 'center';
  const textX: TextX = textXAlignment ?? 'center';
  const textYMobile: TextY = textYAlignmentMobile ?? textY;
  const textXMobile: TextX = textXAlignmentMobile ?? textX;
  const hover: Queries.HoverEffect = hoverEffect ?? 'default';
  const grid = gridBehavior ?? 'dynamicFill';

  if (grid === 'dynamicFill')
    return (
      <div data-testid={`image-grid-container`}>
        <ImageGridDynamicComponent
          {...{
            richImages: richImagesOrDefault,
            textY,
            textX,
            hover,
            optionalImageIcon,
            textYMobile,
            textXMobile,
          }}
        />
      </div>
    );

  throw new Error('ImageGridContainer mode not implemented');
};
